/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';

import { BuilderAelRoutingModule } from './builder-ael-routing.module';
import { AelListComponent } from './components/ael-list/ael-list.component';
import { AelListBusinessService } from './resources/ael-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderAelRoutingModule,
  ],
  providers: [
    AelListBusinessService,
  ],
  declarations: [
    AelListComponent,
  ],
})

export class BuilderAelModule {
}
